import { BsBuilding, BsPerson } from 'react-icons/bs';

/** The two credit types of the org's pool, in display order. `key` matches the API's field prefix. */
export const CREDIT_TYPES = [
	{
		key: 'company',
		label: 'Firmen-Credits',
		short: 'Firmen',
		icon: BsBuilding,
		help: '1 Credit = 1 Firma, die in eine Suchanfrage aufgenommen wird.',
	},
	{
		key: 'contact',
		label: 'Kontakt-Credits',
		short: 'Kontakte',
		icon: BsPerson,
		help: '1 Credit = 1 Ansprechpartner mit angereicherten Daten (z. B. validierter E-Mail).',
	},
];

/** Hatching for credits reserved by running jobs, in the primary palette. */
export const RESERVED_PATTERN = 'repeating-linear-gradient(135deg, #afa3ff 0 4px, #e4e0ff 4px 8px)';

/**
 * @param {string|null} renewsAt - ISO timestamp of the next refill
 * @returns {string|null} e.g. "8. Dezember"
 */
export const formatRenewal = (renewsAt) =>
	renewsAt ? new Date(renewsAt).toLocaleDateString('de-DE', { day: 'numeric', month: 'long' }) : null;
